@if(viewClockIcon()){

<img
  alt="logo"
  class="cursor-pointer"
  [src]="urlIcon + 'clock-grey.svg'"
  class="max-sm:w-[16px]"
/>
}
<span
  class="font-roboto-500"
  [class.efect-inlive]="isLiveTimerVisible()"
  [class.font-inter-600]="isLiveTimerVisible()"
  [class.text-red-2]="isLiveStatusVisible()"
>
  {{ viewStatusMatch() }}
</span>
